import { useMemo } from 'react';
import { ExternalPaymentType } from '@mews-commander/data-access';
import { EnumSelectField } from '@mews-commander/form';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { ExternalPaymentFormField } from '../forms/ProcessPayment/ExternalPaymentForm/schema';
import { useGetExternalPaymentSuspense } from '../../queries';

export const ExternalPaymentTypeSelectField = () => {
    const { data } = useGetExternalPaymentSuspense();

    const enabledExternalPaymentTypes = useMemo(
        () =>
            Object.keys(data?.enabledExternalPaymentTypes ?? {}).map(
                (val) => ExternalPaymentType[val as keyof typeof ExternalPaymentType]
            ),
        [data]
    );
    return (
        <EnumSelectField
            required
            defaultValue={
                enabledExternalPaymentTypes?.length > 0 && ExternalPaymentType[enabledExternalPaymentTypes[0]]
            }
            enumClass={ExternalPaymentType}
            enumPrefix="ExternalPaymentType"
            name={ExternalPaymentFormField.Type}
            label={<LocalizedText textKey={TextKey.Type} />}
            enabledValues={enabledExternalPaymentTypes}
            helper={
                <LocalizedText textKey={TextKey.ProcessPaymentExternalPaymentsOtherPaymentPaymentTypeSelectionHint} />
            }
        />
    );
};
